import { Box, Link } from "@mui/material";
import { SecaoLegal } from "../Legal/secoes";

interface IndiceLegalProps {
  secoes: SecaoLegal[];
}

/** Índice do topo: links de âncora para cada documento renderizado abaixo. */
const IndiceLegal = ({ secoes }: IndiceLegalProps) => (
  <Box
    component="nav"
    aria-label="Índice dos documentos"
    sx={{
      "& ul": { margin: 0, paddingLeft: "20px" },
      "& li": { marginBottom: "4px" },
    }}
  >
    <ul>
      {secoes.map((secao) => (
        <li key={secao.ancora}>
          <Link
            href={`#${secao.ancora}`}
            underline="hover"
            color="primary.dark"
          >
            {secao.titulo}
          </Link>
        </li>
      ))}
    </ul>
  </Box>
);

export default IndiceLegal;
